import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Algebra(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Algebra</h2>
                <li>
                    <Link to={`${url}/integerfunctions`}>Integer Functions</Link>
                </li>
                <li>
                    <Link to={`${url}/variablefunctions`}>Variable Functions</Link>
                </li>
                <li>
                    <Link to={`${url}/linear`}>Linear Functions</Link>
                </li>
                <li>
                    <Link to={`${url}/quadratic`}>Quadratic Functions</Link>
                </li>
                 <li>
                    <Link to={`${url}/graphicequations`}>Graphic Equations</Link>
                </li>
                <li>
                    <Link to={`${url}/polynomials`}>Polynomial Equations</Link>
                </li>
                <li>
                    <Link to={`${url}/exponential`}>Exponential Equations</Link>
                </li> 
                <li>
                    <Link to={`${url}/matrixes`}>Matrixes</Link>
                </li>             
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Algebra; 